var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSwinline = function SvgSwinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sw_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.636 15.364q.567.566 1.203 1.01L16.374 3.84a9 9 0 0 0-2.213-2.214L1.625 14.161q.444.634 1.01 1.203"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M2.636 2.636a9 9 0 0 0-1.637 10.49L13.126 1a9 9 0 0 0-10.49 1.637"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M15.364 15.364A9 9 0 0 0 17 4.874L4.873 17a9 9 0 0 0 10.49-1.636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sw_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgSwinline;